import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_12 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.base;
  const colour1 = '#3B2E2A';
  const colour2 = '#342723';
  const colour3 = '#F2D5B2';
  const colour4 = '#FFEFDA';
  const colour5 = lipColours.base;
  const colour6 = lipColours.base;
  const colour7 = lipColours.shadow;

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M463.7,588.7c-22.2,11.5-106.5,2.4-135.5,0.5c-4.8,0.8-9.4,2.1-13.8,4.1c36.9-1.5,29.5,55.6,87.4,53.2
		c56-2.3,45.7-51,81.4-57.1C483.2,589.4,475.6,588.5,463.7,588.7z"
        />
        <path
          fill={colour1}
          d="M444.8,586.2c-0.4-9.9-20.6-17-45.2-16c-24.5,1-44.1,9.8-43.7,19.7c0.4,9.8,20.6,17,45.2,16
		C425.6,604.8,445.2,596,444.8,586.2z"
        />
        <path
          fill={colour2}
          d="M419.4,595.7c-0.3-7.4-9.6-13-20.9-12.6c-11.2,0.5-20.1,6.8-19.8,14.2c0.3,7.4,9.6,13,20.9,12.6
		C410.8,609.5,419.7,603.1,419.4,595.7z"
        />
        <path
          fill={colour3}
          d="M361.3,589.3c29-2.3,46.4-3.4,74.4-3l-22.2-26l-34.7,3.5L361.3,589.3z"
        />
        <path
          fill={colour4}
          d="M414,584.5c-0.1-2.7-6.9-4.7-15.2-4.3c-8.3,0.3-14.9,2.8-14.8,5.5c0,0.1,0,0.3,0.1,0.4
		c11.2-1.4,18.1-1.4,29.8-1.2C414,584.8,414,584.7,414,584.5z"
        />
        <path
          fill={colour5}
          d="M314.4,593c36.9-1.5,33.4,48.9,87.2,46.7c51.3-2.1,45.9-45,81.7-50.8c0,0-42.8-2.9-84.3,12.1
		C368.7,592.1,338.2,582.9,314.4,593z"
        />
        <path
          fill={colour6}
          d="M432.3,602.6c-8.2,0.1-26.1,2.7-32.7,6.9c-9.7-4.3-25.3-5-35-3.7c0.2,8.6,15.8,19.8,35.9,19
		C418.1,624.1,430.5,611.8,432.3,602.6z"
        />
        <path
          fill={colour7}
          d="M463.7,588.4c-22.2,10.8-22,48.2-62,49.9c-45.2,1.8-44.4-47.4-73.4-49.1c-4.8,0.8-9.4,2-13.8,3.9
		c36.9-1.5,33.5,51.7,87.3,49.5c51.3-2.1,45.8-47.8,81.6-53.6C483.2,588.9,475.6,588.1,463.7,588.4z"
        />
        <path
          fill={colour0}
          d="M399.2,603.9c27.2-16.2,49.6-6,66.5-7.2c3.4-3,13-7.1,17.5-7.8c0,0-43.1-4.4-84.5,10.6
		c-30.2-9-60.6-16.6-84.3-6.5c4-0.2,19.4,5,23.1,8.7C355.8,601.7,379.2,592.6,399.2,603.9z"
        />
        <path
          fill={colour5}
          d="M482.5,585.2c-33.9,1.7-29.3-54.4-63.9-55.3c-6.4-0.2-12.6,7.1-19.1,8.5c-6.5,1.4-8.3-7.7-19.1-7
		c-33.1,2.1-40,62.2-64.7,58.6l-1.3,2.9c11.8,5.4,47.2,17.6,67.2-20.7c0,0,19.4,8,33-0.7c0,0,9.4,30.9,68.7,17.3L482.5,585.2z"
        />
        <path
          fill={colour7}
          d="M482.5,585.2c-7.3,0.4-12.8-1.9-17.3-5.8c-25.7,9-62.7-15.9-56.6-45.5c-3,1.9-6.1,3.9-9.2,4.6
		c-4.7,1-7-3.5-11.9-5.8c17.7,25.6-36.9,54.7-60.2,54c-3.5,2.7-7.3,4-11.7,3.4l-1.3,2.9c11.8,5.4,42.2,17.8,71.5-18.2
		c0,0,12.1,6,26-0.3c0,0,19.6,31,71.3,14.4L482.5,585.2z"
        />
        <path
          fill={colour0}
          d="M396.5,601.1c0,0,3.1,6.3,3.2,12.3c0,0-0.4-10.5,2.8-12.8L396.5,601.1z"
        />
        <path
          fill={colour7}
          d="M402.2,638.9c0,0-2.7-5.1-2.4-9.9c0,0-0.3,8.3-3.7,10.1L402.2,638.9z"
        />
        <path
          fill={colour7}
          d="M434.8,610.3c0,0,4.4,1.7,5.9,9.1l2.2-2C443,617.4,439.3,611.2,434.8,610.3z"
        />
        <path
          fill={colour7}
          d="M417.4,623.9c0,0,4.1,4.3,3.2,12.3l2.5-1.3C423,634.9,421.8,627.2,417.4,623.9z"
        />
        <path
          fill={colour7}
          d="M375.8,624.7c0,0-3.2,3.2-2.6,10.2l-1.9-1.4C371.3,633.6,372.3,627.1,375.8,624.7z"
        />
        <path
          fill={colour7}
          d="M363,609.4c0,0-4.1,1-6.8,6.3l-1.6-2.7C354.5,612.9,359,609.6,363,609.4z"
        />
        <path
          fill={colour6}
          d="M428.7,534.1c-5.3-3.5-12.3-3.6-15.9,0.5c-2.8,3.2-1.4,11.6,3.9,15.3c5.2,3.6,20,6.1,23,3
		C442.6,549.8,435.2,538.4,428.7,534.1z"
        />
        <path
          fill={colour6}
          d="M366.4,537.7c5.3-4,13.1-5.1,17.2-1.1c3.2,3.2,1.8,12.4-3.4,16.6c-5.2,4.2-20.5,7.9-23.8,4.8
		C353,555.1,359.9,542.7,366.4,537.7z"
        />
        <path
          fill={colour0}
          d="M384.6,568.2c0.3,6.2-2,10.5-7.6,16c2.9-2.7,6.3-5.1,9.3-8.7c0,0,11.6,6.1,25.5-0.2c0,0,1.9,2,5.9,5.5
		c-5.5-5.8-5.2-12.7-5.2-12.7C411.1,578.3,390.1,581.1,384.6,568.2z"
        />
        <path
          fill={colour0}
          d="M419.9,595.2l-1.7,0.3c0,0,1.3,3,1.2,5.8C419.4,601.2,420.5,598.5,419.9,595.2z"
        />
        <path
          fill={colour6}
          d="M447,557c-0.5-1.8-2.2-4.2-3.4-4.4c-1.2-0.3-2.2,2.7-1.7,4.5c0.5,1.8,2.6,2.5,3.8,2.8
		C446.9,560.1,447.5,558.9,447,557z"
        />
        <path
          fill={colour6}
          d="M351.5,563.6c0.9-1.3,1.6-3.7,1.2-4.5c-0.4-0.9-2.8,0.2-3.7,1.5c-0.9,1.3-0.3,3,0.1,3.9
		C349.5,565.3,350.6,564.9,351.5,563.6z"
        />
        <path
          fill={colour0}
          d="M365.3,584.6c0.3,4.4-1.6,9.1-2.8,11.3l3.5-2.3C367.1,588.8,365.3,584.6,365.3,584.6z"
        />
        <polygon fill={colour1} points="378.6,588.7 379.3,586.4 380.2,589 	" />
        <polygon fill={colour1} points="416.2,586.6 416.9,584.3 417.7,586.8 	" />
      </g>
    </>
  );
};

export default Mouth_12;
